module.exports = __webpack_public_path__ + "img/pl_Ecran 6.dec3189d.jpg";